export const protobufPackage = "snapchat.cdp.cof";
export enum ContactAuthorizationStatus {
    CONTACT_AUTH_STATUS_UNSET = 0,
    STATUS_NOT_DETERMINED = 1,
    RESTRICTED = 2,
    DENIED = 3,
    AUTHORIZED = 4,
    LIMITED_ACCESS = 5,
    UNRECOGNIZED = -1
}
